module.exports = __webpack_public_path__ + "img/masterCard.5fd4c52f.png";